/** @jsxImportSource @emotion/react */
import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { LocaleContext } from "../../context/LocaleContext";
import Button from "../Button";
import {
  txtBrideGroomName,
  txtFrom,
  txtGuestPlaceholder,
  txtLandingButton,
  txtLandingTitle,
} from "./locales";
import {
  styLanding,
  styLandingWrapper,
  styLandingGuest,
  styLandingInfo,
  styLandingAction,
} from "./styles";

interface Props {
  isOpen?: boolean;
  onClickOpenInvitation: () => void;
}

const LandingSection = ({ isOpen, onClickOpenInvitation }: Props) => {
  const { lang } = useContext(LocaleContext);
  const { to } = useParams();

  const guestName = decodeURIComponent(to || "");

  return (
    <section css={styLanding}>
      <div css={styLandingWrapper}>
        <div css={styLandingInfo}>
          <p>{txtLandingTitle[lang]}</p>
          <h1>{txtBrideGroomName[lang]}</h1>
          <p>26 &#x2022; 08 &#x2022; 2023</p>
        </div>
        <div css={styLandingAction(isOpen)}>
          <div css={styLandingGuest}>
            <p>{txtFrom[lang]}</p>
            <h4>{guestName ? guestName : txtGuestPlaceholder[lang]}</h4>
          </div>
          <Button onClick={onClickOpenInvitation}>
            {txtLandingButton[lang]}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default LandingSection;
